document.querySelectorAll('a[href*="#opencookiebot"]').forEach(function (link) {
    link.addEventListener("click", function (event) {
        event.preventDefault();

        if (
            typeof CookieScript !== "undefined" &&
            typeof CookieScript.instance.show === "function"
        ) {
            CookieScript.instance.show();
        } else {
            console.warn("CookieScript function not found.");
        }
    });
});
